import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Dispatch, SetStateAction } from "react";

type DeactivationRequestDialogProps = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onConfirm: () => void;
};

export default function DeactivationRequestDialog({
  open,
  setOpen,
  onConfirm,
}: DeactivationRequestDialogProps) {
  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogContent>
        <DialogContentText>
          <DialogTitle>Request Account Deactivation</DialogTitle>
          Once deactivated, you will no longer have access to this account, and
          you will no longer receive emails from MagicalTrip. <br />
          <br />
          If you would like to reactivate your account in the future, you can
          contact us anytime.
        </DialogContentText>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button
            onClick={() => {
              onConfirm();
              setOpen(false);
            }}
            style={{ color: "#f50057" }}
          >
            Send Request
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}
